import {management} from '../../../../index.js' //api
import {VolumeRepository} from "../../../infra/knex/repositories/volume"
import {GetVolumeByIdSectorAndTimeUseCase} from "./getVolumeByIdSectorAndTime"


export  const getVolumeByIdSectorAndTimeUseCase=new GetVolumeByIdSectorAndTimeUseCase(new VolumeRepository(management))
